import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WHATSAPP_LINK } from "@/lib/api";
import { useSiteContent } from "@/context/SiteContentContext";

export const Footer = () => {
  const { content } = useSiteContent();
  const f = content.footer;
  const nav = content.navbar;
  const contact = content.contact;

  return (
    <footer className="bg-[var(--navy)] text-[var(--ivory)] pt-20 pb-10 relative overflow-hidden" data-testid="site-footer">
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full border border-[var(--gold)]/15" />
      <div className="pointer-events-none absolute bottom-10 right-10 w-32 h-32 border border-[var(--gold)]/30 rounded-tl-full" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo variant="dark" size="lg" />
          <p className="mt-6 text-sm text-[var(--ivory)]/70 leading-relaxed max-w-md font-light whitespace-pre-line">
            {f.tagline}
          </p>
        </div>

        <div>
          <h4 className="font-serif-luxe text-xl mb-5 text-[var(--gold)]">{f.explore_title}</h4>
          <ul className="space-y-3 text-sm font-light">
            <li><Link to="/" className="hover:text-[var(--gold)] transition-colors">{nav.link_home}</Link></li>
            <li><Link to="/projeler" className="hover:text-[var(--gold)] transition-colors">{nav.link_projects}</Link></li>
            <li><Link to="/hakkimizda" className="hover:text-[var(--gold)] transition-colors">{nav.link_about}</Link></li>
            <li><Link to="/iletisim" className="hover:text-[var(--gold)] transition-colors">{nav.link_contact}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-luxe text-xl mb-5 text-[var(--gold)]">{f.contact_title}</h4>
          <ul className="space-y-3 text-sm font-light text-[var(--ivory)]/80">
            <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[var(--gold)]" /> <a href={`tel:${contact.phone_display.replace(/\s/g, "")}`} className="hover:text-[var(--gold)]">{contact.phone_display}</a></li>
            <li className="flex items-start gap-2"><MessageCircle size={15} className="mt-0.5 text-[var(--gold)]" /> <a href={WHATSAPP_LINK(contact.default_whatsapp_message, contact.whatsapp_number)} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--gold)]">WhatsApp</a></li>
            <li className="flex items-start gap-2"><Instagram size={15} className="mt-0.5 text-[var(--gold)]" /> <a href={contact.instagram_url} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--gold)]">@{contact.instagram_handle}</a></li>
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[var(--gold)]" /> {f.address_short}</li>
          </ul>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 mt-16 pt-6 border-t border-[var(--gold)]/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs tracking-[0.2em] uppercase text-[var(--ivory)]/50">
          © {new Date().getFullYear()} {content.brand.name} {content.brand.sub} — {f.copyright}
        </p>
        <Link to="/admin" className="text-xs tracking-[0.2em] uppercase text-[var(--ivory)]/50 hover:text-[var(--gold)]" data-testid="footer-admin-link">
          {f.admin_link_label}
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
